// export const BASE_URL = process.env.REACT_APP_BASE_URL_FILE_SERVER || "https://j1.engagevida.com/"
export const BASE_URL = process.env.REACT_APP_BASE_URL_FILE_SERVER || "https://jeweladmin.veidalabs.com/"